export const stalledTransactionEndpoints = (builder) => ({
    getStalledTransactions: builder.query({
        query: (flaggedId) => ({ url: `/stalled-transactions/details/${flaggedId}`, method: 'get' }),
        providesTags: ['stalled transaction'],
    }),

    resolveTransaction: builder.mutation({
        query: ({ ...data }) => ({ url: `/stalled-transactions`, method: 'post', body: { ...data } }),
        invalidatesTags: ['stalled transaction'],
    }),
    downloadStalledTransactionsReport: builder.mutation({
        query: ({ userId, status, userGroup, startDate, endDate, stalledTransactionType, format }) => ({
            url: `/stalled-transactions/report/${format}?userGroup=${userGroup || ""}`
                + `&userId=${userId || ""}`
                + `&status=${status || ""}`
                + `&stalledTransactionType=${stalledTransactionType || ""}`
                + `&startDate=${startDate || ""}`
                + `&endDate=${endDate || ""}`,
            method: 'post'
        }),
    }),
    blockUser: builder.mutation({
        query: ({ userId, username, status, reason, meta }) => ({ url: `/users/${userId}/status`, method: 'put', body: { meta, username, status, reason } })
    }),
    getTransactionAccountDetails: builder.query({
        query: ({ userId, accountId }) => ({
            url: `/users/account/${userId}/${accountId}`,
            method: "GET",
        }),
        providesTags: ["stalled transaction"],
    }),

    getActivityDetails: builder.query({
        query: ({ userId, query }) => ({
            url: `/transactions?userId=${userId}&query=${query}`,
            method: "GET",
        }),
        providesTags: ["stalled transaction"],
    }),
    

})
